import { AxiosResponse } from 'axios';
import axiosInstance from '../../axios-config/axios-base-query';
import * as FileSaver from 'file-saver';

export const crmFilesAPI = {
  getDocumentBlobById(documentId: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`/gk/documents/${documentId}/download`, {
      responseType: 'blob',
    });
  },

  download(
    documentId: string,
    fileName: string,
    fileMimeType: any = ''
  ): Promise<AxiosResponse<any>> {
    return this.getDocumentBlobById(documentId).then((resp) => {
      return new Promise((resolve, reject) => {
        // Map MIME types to proper file extensions
        const mimeToExtension: { [key: string]: string } = {
          'application/vnd.ms-excel': 'xls',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
          'application/msword': 'doc',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
          'application/vnd.ms-powerpoint': 'ppt',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
          'application/pdf': 'pdf',
          'image/jpeg': 'jpg',
          'image/png': 'png',
          'image/gif': 'gif',
          'text/plain': 'txt',
        };

        const extension = mimeToExtension[fileMimeType] || fileMimeType.split('/')[1] || '';
        const realFileName = fileName.endsWith(`.${extension}`)
          ? fileName
          : `${fileName}.${extension}`;

        try {
          FileSaver.saveAs(resp.data, realFileName);
          resolve(resp);
        } catch (e) {
          reject(e);
        }
      });
    });
  },

  getDocumentBlobByProjectAndSlug(
    projectId: string,
    slug: string
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.get(
      `/gk/documents/download/slug/${projectId}/${slug}`,
      {
        responseType: 'blob',
      }
    );
  },

  downloadDocumentBySlug(
    projectId: string,
    slug: string,
    fileName: string,
    fileMimeType: any
  ) {
    return this.getDocumentBlobByProjectAndSlug(projectId, slug).then(
      (resp) => {
        return new Promise((resolve, reject) => {
          try {
            FileSaver.saveAs(
              resp.data,
              fileName
              // `${fileName}.${mime.getExtension(fileMimeType)}`
            );
            // resolve()
          } catch (e) {
            reject(e);
          }
        });
      }
    );
  },

  getThumbnail(documentId: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`/gk/documents/${documentId}/download-thumbnail`, {
      responseType: 'blob',
    });
  },

  generateFile(
    projectId: string,
    standardSlug: string
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.post(
      `/gk/documents/${projectId}/generate/${standardSlug}`,
      {},
      {
        responseType: 'blob',
      }
    );
  },

  /**
   * MODULE UPSELL
   */
  getTempAmendementFile(
    projectId: string,
    editableConfig: any
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.post(
      `/gk/configurations/upsells/${projectId}/get-temp-amendement-file`,
      {
        editableConfig,
      },
      { responseType: 'blob' }
    );
  },

  /**
   * MODULE CONFIGURATION
   */
  generateQuoteDocumentAndGetFile(
    projectId: string | number,
    configurations: any
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.post(
      `/gk/configurations/${projectId}/generate-quote-document`,
      configurations,
      {
        responseType: 'blob',
      }
    );
  },

  getQuoteFileFromMainConfig(
    projectId: string | number
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.get(
      `/gk/configurations/${projectId}/get-quote-file-from-main-config`,
      {
        responseType: 'blob',
      }
    );
  },

  /**
   * MODULE CATALOGUE
   */
  downloadIfc(reference: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`/gk/catalogue/bim/${reference}/file`, {
      responseType: 'blob',
    });
  },
};
